module.exports = __webpack_public_path__ + "static/media/22_plantilla_combo_rectangular_marco_comida_31.0d39c6b2.png";